<template>
    <div class="location-edit">
        <Header :app="app" :left="true" :title="app.selectedLocation.name">
            <template v-slot:left>
                <router-link :to="{ name: 'location', params: { id: app.selectedLocation.id } }">
                    &laquo;
                </router-link>
            </template>
        </Header>

        <div class="content">
            <div class="field">
                <label>Location Name</label>
                <input type="text" v-model="app.selectedLocation.name" v-on:blur="app.save(app.selectedLocation, 'name')" autofocus>
            </div>

            <div class="field">
                <button v-on:click="app.remove(app.locations, app.selectedLocation, 'location', true)" class="full-width button-small button-gray">
                    Delete This Location
                </button>
            </div>

            <!-- <pre>
                How often does this location meet?
                Repeats weekly [choose days]
                Repeats monthly [choose dates]
            </pre> -->
        </div>
    </div>
</template>

<script>
import Header from '@/components/header/component.vue';

export default {
    name: 'locationEdit',
    components: {
        Header
    },
    props: ['app']
};
</script>
